import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Experience the Best Coffee in Town"} subTitle={"Wake Up and Sip"} linear sideHeading />
        <Button link={"Booking"} title={"Book Table"} />

      </div>
    </section>
  );

};

export default Banner;